import { useEffect, useState } from "react";
import { Select } from "antd";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../store/Hooks";
import _ from "lodash";
import { mdlHotel } from "../../models/domain/Hotel";

export type HotelSelectProps = {
    onChange?: Function;
    value?: string | string[];
    disabled?: boolean;
    defaultValue?: string | string[];
    excludedValue?: string;
    mode?: 'multiple' | 'tags' | undefined;
    sendObject?: boolean;
    defaultAllSelected?: boolean;
    maxTagCount?: number;
}

export const HotelSelect = (props: HotelSelectProps) => {
    const [selectedHotel, setSelectedHotel] = useState<string | string[]>();
    const { t } = useTranslation();
    const userHotels = useAppSelector(x => x.site.userHotels);
    const agencyLimitedHotelPaximumIds = useAppSelector(x => x.site.agencyLimitedHotelPaximumIds);

    useEffect(() => {
        if (props.defaultValue) {
            setSelectedHotel(props.defaultValue)
        }
        if (props.value)
            setSelectedHotel(props.value);

        var userHotelSelections = userHotels?.filter(x => x.requirePayment == false).map(h => h.id);
        if (userHotelSelections && props.defaultAllSelected) {
            if (!(props.value as string[]).every(element => userHotelSelections?.includes(element)) &&
                userHotelSelections.every(element => (props.value as string[]).includes(element)))
                props.onChange && props.onChange(userHotels?.filter(x => x.requirePayment == false).map(h => h.id));
        }
    }, [props]);


    const handleSendObject = (option: any) => {
        const selectedOption = Array.isArray(option) ? option.map(opt => opt) : option;
        props.onChange!(selectedOption);
    }

    const getHotelSelectionText = (hotel: mdlHotel) => {
        let isHotelInHotelAllowedAgencies = agencyLimitedHotelPaximumIds?.includes(hotel.paximumId) ?? false;

        return `${hotel.requirePayment == true ? "💳" : ""} ${isHotelInHotelAllowedAgencies ? "🔒" : ""} ${hotel.localName}`;
    }

    return (
        <>
            {
                userHotels
                &&
                <Select
                    disabled={props.disabled}
                    size="middle"
                    maxTagCount={props.maxTagCount ?? undefined}
                    mode={props.mode}
                    value={props.mode == "multiple" ? selectedHotel as string[] : selectedHotel as string}
                    style={{ width: "100%" }}
                    defaultValue={props.defaultAllSelected ? userHotels?.map(x => x.id) : props.defaultValue}
                    onChange={(value: string | string[], option: any) =>
                        props.sendObject ? handleSendObject(option) : props.onChange!(value)}
                    showSearch
                    placeholder={t("common.chooseHotel")}
                    filterOption={(input, option) =>
                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                    }
                    options={userHotels.map(h => ({
                        ...h,
                        label: getHotelSelectionText(h),
                        value: h.id,
                        disabled: h.requirePayment == true
                    })).filter((x) => !props.excludedValue || (props.excludedValue && x.value != props.excludedValue))}
                />
            }

        </>
    )
}
